/**
 * Converts held up/down input into discrete whole-degree aim steps:
 * a tap produces exactly one step, holding repeats after a short delay.
 * Used by the offline authority simulation and by the online client (which
 * forwards each step to the server as a discrete 'aim' action).
 */
const INITIAL_REPEAT_DELAY = 0.3;
const REPEAT_INTERVAL = 1 / 30;

export class AimStepper {
  private wasHeld = false;
  private repeatTimer = 0;

  /** Steps to apply this tick (positive = up). 0 when nothing to do. */
  update(deltaTime: number, up: boolean, down: boolean): number {
    const dir = up ? 1 : down ? -1 : 0;
    if (dir === 0) {
      this.wasHeld = false;
      this.repeatTimer = 0;
      return 0;
    }

    let steps: number;
    if (!this.wasHeld) {
      this.wasHeld = true;
      this.repeatTimer = INITIAL_REPEAT_DELAY;
      steps = 1;
    } else {
      steps = 0;
      this.repeatTimer -= deltaTime;
      while (this.repeatTimer <= 0) {
        steps++;
        this.repeatTimer += REPEAT_INTERVAL;
      }
    }
    return steps * dir;
  }

  reset(): void {
    this.wasHeld = false;
    this.repeatTimer = 0;
  }
}
